// extracted by mini-css-extract-plugin
module.exports = {"root":"P_b9","input":"P_cw","label-col":"P_dn","labelCol":"P_dn","label":"P_cr","sublabel":"P_dp","actions":"P_dq","button":"P_b1","plus-btn":"P_dr","plusBtn":"P_dr"};